import { useQuery } from '@tanstack/react-query';

import { fetchTeamFiles } from '@/api/v4/team-files.api';
import { QueryKey } from '@/config/query-client';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';

import { teamIdState } from '../../../team.state';
import { useAtomValue } from 'jotai';

export const useTeamFiles = () => {
  const teamId = useAtomValue(teamIdState);

  const { hasRequiredPermission } = useUserPermissions();

  const fetchFiles = async () => {
    if (!teamId) return [];

    return fetchTeamFiles(teamId);
  };

  return useQuery({
    queryKey: [QueryKey.TeamFiles, teamId],
    queryFn: fetchFiles,
    enabled: !!teamId && hasRequiredPermission(PERMISSION.VIEW_FILES),
    staleTime: 1000 * 60 * 5,
  });
};
